import React from "react";

import type { renderPillArgument } from "~/integrations/actionItemIntegration";
import { WidgetInner } from "~/integrations/actionItemIntegration/Widget";

import { TrelloLogo } from "./TrelloLogo";

export const trelloSpecificDataNodeTypename = "TrelloActionItemIntegrationSpecificDataNode";

export function TrelloActionItemIntegrationLinkWidget({ actionItemLink, customClassName }: renderPillArgument) {
	if (actionItemLink.integrationData.__typename !== trelloSpecificDataNodeTypename) {
		throw new Error("Incorrect integration to render pill");
	}
	const updating = actionItemLink.syncStatus !== "DONE_SYNCING_EXTERNALLY";

	const data = actionItemLink.integrationData;
	const url = `https://trello.com/c/${data.externalCardId}/`;

	return (
		<WidgetInner logo={<TrelloLogo />} updating={updating} url={url} customClassName={customClassName}>
			{data.boardName ? data.boardName : "Syncing"}
		</WidgetInner>
	);
}
